import { observer } from 'mobx-react-lite';
import { FC, useEffect, useRef, useState } from 'react';

import { RoomCallPopupContent } from '@gem/call/components/RoomCallPopupContent/RoomCallPopupContent';
import { RoomCallPreviewVideo } from '@gem/call/components/RoomCallPreviewVideo/RoomCallPreviewVideo';
import { getMascotImageSrc } from '@gem/utils';

import Entities from 'STORE';

import { ICallPreviewDevicesPresenter } from '../CallPreview.devices.presenter';
import { ICallPreviewPresenter } from '../CallPreview.presenter';
import { StartCall } from '../StartCall/StartCall';
import styles from './CallDevicesPreview.styles.m.css';

interface ICallDevicesPreviewProps {
  presenter: ICallPreviewPresenter;
  devicesPresenter: ICallPreviewDevicesPresenter;
}

export const CallDevicesPreview: FC<ICallDevicesPreviewProps> = observer(
  ({ presenter, devicesPresenter }) => {
    const backgroundPanelRef = useRef<HTMLDivElement>(null);
    const [refState, setRefState] = useState<HTMLDivElement | null>(null);

    useEffect(() => {
      setRefState(backgroundPanelRef.current);
    }, [backgroundPanelRef]);

    return (
      <>
        <RoomCallPopupContent
          className={presenter.ongoingCall ? styles.fixedContainer : undefined}
          lightImageName={getMascotImageSrc(PROJECT_CONFIG.imageAssets.previewLogoLight)}
          darkImageName={getMascotImageSrc(PROJECT_CONFIG.imageAssets.previewLogoDark)}
          applicationTheme={Entities.appearance.theme}
        >
          <div className={styles.content}>
            <RoomCallPreviewVideo
              onMediaPermissionsChanged={presenter.onMediaPermissionsChanged}
              backgroundPanelContainer={refState}
              avatar={{
                url: null,
                colorIndex: null,
                title: presenter.selfName,
              }}
              ref={presenter.startCallRef}
              initialMedia={{
                isVideoMuted: true,
                isAudioMuted: true,
              }}
              onChangeAudioMuted={devicesPresenter.onChangeAudioMuted}
              onChangeVideoMuted={devicesPresenter.onChangeVideoMuted}
              onChangeInitialDevicesIds={devicesPresenter.onChangeInitialDevicesIds}
            />
            <StartCall
              waitingRoomMemberStatus={presenter.waitingRoomMemberStatus}
              onStart={presenter.onStart}
              onCancel={presenter.onCancel}
              isLoading={presenter.isLoading && !presenter.hasMediaPermissions}
            />
          </div>
        </RoomCallPopupContent>
        <div
          className={styles.backgroundContainer}
          ref={backgroundPanelRef}
        />
      </>
    );
  }
);
